import { modalController } from '@ionic/vue';
import LegalDocumentModal from '@/components/legal/LegalDocumentModal.vue';

export async function openLegalDocument(documentKey) {
  const modal = await modalController.create({
    component: LegalDocumentModal,
    componentProps: { documentKey },
  });
  return modal.present();
}
